import { Pipe, PipeTransform } from '@angular/core';
import {EnumNamesService} from "@portal/shared/services/enum-names.service";

@Pipe({ name: 'transactionCategoryName' })
export class TransactionCategoryNamePipe implements PipeTransform {

    constructor(private _enumsService: EnumNamesService) {}

    transform(value: number): string {
        return this._enumsService.getTransactionCategoryName(value);
    }
}
